module.exports = __webpack_public_path__ + "img/Ferdinand_Gedenktafel_kl.83e2d493.jpg";